import ForwardingLocationContainer from './ForwardingLocationContainer';
export default ForwardingLocationContainer;
